import {computed, makeObservable} from 'mobx';

import type {CachedMediaFactory} from '../../../core/models/CachedMedia/CachedMedia.factory';
import type {RemoteFileStorageService} from '../../../core/system/remoteFileStorage/RemoteFileStorage.service';

import {BaseImageModel} from './BaseImage.model';

export class ImageModel extends BaseImageModel {
  constructor(
    cachedMediaFactory: CachedMediaFactory,
    remoteFileStorageService: RemoteFileStorageService,
  ) {
    super(cachedMediaFactory, remoteFileStorageService);
    makeObservable(this, {isSrcReady: computed});
  }

  get isSrcReady() {
    return this.isVisibleFlag.value;
  }
}
